export enum ROUTES {
  MAIN = '/',
  HELP_CENTER_CHAT = '/help-center-chat',
  SUPPORT_CHATBOT = '/support-chatbot',
  CONTACT = '/contact',
  WIDGET = '/widget',
  WIDGET_ALL = '/widget/*',
  POST_LOGIN = '/post-login',

  CHATBOT_API = '/_api/chatbot',
  WIDGET_API = '/_api/widget',
  CONTEXT_API = '/_api/context',
  ARTICLES_API = '/_api/articles',
  CATEGORIES_API = '/_api/categories',
  MESSAGES_API = '/_api/messages',
  SEARCH_API = '/_api/search',
  IS_SUPPORT_CONTACT_PROMPT_API = '/_api/is-support-contact-prompt',
  REQUEST_SUCCESS_MANAGER_API = '/_api/request-success-manager',
  MEDIA_TOKEN_API = '/_api/media-token',
  MEDIA_UPLOAD_URL_API = '/_api/media/upload-url',
  WIXMP_UPLOAD_URL_API = '/_api/media/wixmp-upload-url',

  HELP_CENTER_SESSION = '/_api/help-center-session',

  META_ARTIFACT_VERSION = '/meta/artifact-version',
}

export enum WIDGET_ROUTES {
  MODEL = '/model',
  INIT = '/init',
  RUNTIME = '/runtime',
  SESSION = '/session',
  HOMEPAGE = '/homepage',
  LAST_INTERACTED_SITE = '/last-interacted-site',
  SITES = '/sites',
}

export enum CHATBOT_ROUTES {
  DEALER_OFFER = '/offer',
  SESSION = '/session',
  START_CHAT = '/start-chat',
  RESTART_CHAT = '/restart-chat',
  USER_ACTION = '/user-action',
  CREATE_SESSION_WITH_PAYLOAD = '/create-session-with-payload',
  CONVERSATION_FEEDBACK = '/conversation-feedback',
}

export enum MESSAGE_ROUTES {
  MARK_AS_READ = '/mark-as-read',
}

export enum ARTICLE_ROUTES {
  ARTICLE_BY_ID = '/:id',
  ARTICLE_BY_URI = '/uri/:uri',
  ARTICLE_VOTE = '/:articleId/vote',
  ARTICLE_ANALYTICS = '/:id/analytics',
}

export enum CATEGORY_ROUTES {
  CATEGORIES = '',
  CATEGORY_BY_URI = '/uri/:uri',
  ARTICLES_BY_CATEGORY = '/:categoryId/articles',
}

export enum EXTERNAL_ROUTES {
  INCIDENTS_TEST = 'https://apps.wix.com/answers-wix-integration/urgent-banner',
  INCIDENTS = 'https://status.wix.com/api/v2/incidents.json',
}

export enum ROUTES_WITH_REDIRECT {
  STATEMENT = '/statement',
}
